import script from "./Estado.vue?vue&type=script&setup=true&lang=js"
export * from "./Estado.vue?vue&type=script&setup=true&lang=js"

import "./Estado.vue?vue&type=style&index=0&id=10bb295c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10bb295c"]])

export default __exports__